<template>
  <div class="grid grid-cols-1 gap-y-2">
    <div v-if="salesPhone || salesEmail" class="text-sm font-bold text-[color:var(--color-footer-top-text)]">
      {{ $t("shared.layout.footer.sales") }}
    </div>
    <a
      v-if="salesPhone"
      class="footer-link text-sm font-medium text-[color:var(--color-footer-top-link)] hover:text-[color:var(--color-footer-top-link-hover)]"
      :href="`tel:${salesPhone}`"
      @click="gtmSendGenerateLeadEvent('FooterContactUsSalesPhone')"
    >
      {{ salesPhone }}
    </a>
    <a
      v-if="salesEmail"
      class="footer-link truncate text-sm font-medium text-[color:var(--color-footer-top-link)] hover:text-[color:var(--color-footer-top-link-hover)]"
      :href="`mailto:${salesEmail}`"
      @click="gtmSendGenerateLeadEvent('FooterContactUsSalesEmail')"
    >
      {{ salesEmail }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useThorlabsGtm } from "@/shared/gtm/gtm";

interface Props {
  salesPhone?: string;
  salesEmail?: string;
}

defineProps<Props>();

const { gtmSendGenerateLeadEvent } = useThorlabsGtm();
</script>
